import { AdvancedGridTable } from "@apex/component-library";
import { Box } from "@chakra-ui/react";
import { ColDef, IStatusPanelParams } from "ag-grid-community";

import { RequirementsSummaries } from "../../../api/useGetRequirements";
import { APP_ID } from "../../../utils/constants";
import getDateString from "../../../utils/getDateString";
import { getCurrencyValue } from "../../CallAlertsAuxWindow/auxUtils";

type Props = { requirementsSummaries: RequirementsSummaries[] };

export default function RequirementsSummariesTable({
  requirementsSummaries,
}: Props) {
  if (requirementsSummaries?.length === 0) {
    return (
      <Box p={4} bg="white">
        No Requirement Summaries
      </Box>
    );
  }

  const columnDefs: ColDef<RequirementsSummaries>[] = [
    {
      headerName: "Trade Type",
      valueGetter: params => params.data?.type,
      width: 130,
      filter: "agTextColumnFilter",
      valueFormatter: ({ value }) => value.replace("REQ_", ""),
    },
    {
      headerName: "Class",
      valueGetter: params => params.data?.reqClass,
      filter: "agTextColumnFilter",
      width: 130,
    },
    {
      headerName: "Requirement",
      valueGetter: params => params.data?.totalRequirement,
      valueFormatter: ({ value }) => getCurrencyValue(value),
      filter: "agNumberColumnFilter",
      type: "rightAligned",
      width: 180,
    },
    {
      headerName: "Process Date",
      colId: "processDate",
      type: "date",
      valueGetter: params =>
        params.data?.processDate && getDateString(params.data?.processDate),
      filter: "agDateColumnFilter",
      width: 230,
    },
  ];

  const statusBar = (props: IStatusPanelParams<RequirementsSummaries>) => {
    if (requirementsSummaries?.length === 0) return null;
    const total = requirementsSummaries?.reduce((acc, curr) => {
      return Number(acc) + Number(curr.totalRequirement);
    }, 0);
    return (
      <Box py={2} ml={-2} fontWeight="semibold">
        <Box as="span">Requirements Total:</Box>{" "}
        <Box as="span">{total ? getCurrencyValue(total) : 0}</Box>
      </Box>
    );
  };

  return (
    <AdvancedGridTable
      columnDefs={columnDefs}
      rowData={requirementsSummaries}
      gridId={`${APP_ID}.requirements-class-search-results`}
      rowStyle={{ cursor: "pointer" }}
      rowClass="requirements-class-row"
      statusBar={{
        statusPanels: [
          {
            statusPanel: statusBar,
            align: "left",
          },
        ],
      }}
      hasFiltersPanel
    />
  );
}
